module.exports = __webpack_public_path__ + "static/media/ben-logo-header.5254ce62.svg";